var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.b0c1e60c67394af83d9098504cdf88cd.svg#g';
                    var viewUrl = 'sprites.b0c1e60c67394af83d9098504cdf88cd.svg#view-g';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };